import { createReducer } from 'redux-act';
import { fetchEventsJSONSuccess } from "modules/actions";
import { IEvent } from 'modules/types';

const defaultState: IEvent[] = [];

export const events = createReducer<typeof defaultState>({}, defaultState)
	.on(fetchEventsJSONSuccess, (state, payload) => payload)
;
